export default __webpack_public_path__ + "b1441331b06749c1d2a4ee7406a8b746.png";